import { ChevronFirst, ChevronLast, ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/use-translation'

interface PaginationNavigationProps {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  canGoPrevious: boolean
  canGoNext: boolean
  goToFirst: () => void
  goToPrevious: () => void
  goToNext: () => void
  goToLast: () => void
  showFirstLast?: boolean
}

/**
 * Component for pagination navigation buttons (first, previous, next, last).
 */
export function PaginationNavigation({
  canGoPrevious,
  canGoNext,
  goToFirst,
  goToPrevious,
  goToNext,
  goToLast,
  showFirstLast = true,
}: PaginationNavigationProps) {
  const t = useTranslation()

  return (
    <div className="flex items-center space-x-1">
      {showFirstLast && (
        <Button
          variant="outline"
          size="icon"
          className="hidden size-8 lg:flex"
          onClick={goToFirst}
          disabled={!canGoPrevious}
        >
          <span className="sr-only">{t('dataTable.goToFirstPage')}</span>
          <ChevronFirst className="h-4 w-4" />
        </Button>
      )}
      <Button
        variant="outline"
        size="icon"
        className="size-8"
        onClick={goToPrevious}
        disabled={!canGoPrevious}
      >
        <span className="sr-only">{t('dataTable.goToPreviousPage')}</span>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        className="size-8"
        onClick={goToNext}
        disabled={!canGoNext}
      >
        <span className="sr-only">{t('dataTable.goToNextPage')}</span>
        <ChevronRight className="h-4 w-4" />
      </Button>
      {showFirstLast && (
        <Button
          variant="outline"
          size="icon"
          className="hidden size-8 lg:flex"
          onClick={goToLast}
          disabled={!canGoNext}
        >
          <span className="sr-only">{t('dataTable.goToLastPage')}</span>
          <ChevronLast className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
